import { getHttpClient } from "@/core/api";

export async function getAllShippers() {
  const response = await getHttpClient().get("v2/organizations/shippers");
  return response.data;
}

export async function getShippersWithTransports() {
  const response = await getHttpClient().get("v2/organizations/shippers/with-transport");
  return response.data;
}
